module.exports = __webpack_public_path__ + "img/success.15c3d622.png";